import React, { useEffect, useState } from 'react'
import { Form, Row, Col, Select, Button } from 'antd'
import { CameraOutlined, PrinterOutlined } from '@ant-design/icons'
import { toast } from 'react-toastify'
import axiosInstance from '../../Utils/axiosInstance'
import {
  GetCardPrintingMembers,
  GetCardPrintingData,
} from "../../API's/AdminApi"
import Logo from '../../Assets/logo.png'
import StaticQR from '../../Assets/qr.png'
import userPhoto from '../../Assets/user.png'
import { PdfPath } from "../../API's/UserApi"

const { Option } = Select

const STATIC_CARD = {
  name: 'Rohit Patil',
  admissionType: 'Lifetime Member',
  validFrom: '01-Jan-2025',
  validTo: '31-Dec-2030',
  mobile: '9876543210',
  photo: null,
  qrCode: 'MEMBER-001|Rohit Patil|9876543210',
}

export default function CardPrinting() {
  const [members, setMembers] = useState([])
  const [cardData, setCardData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const getMembers = async () => {
    try {
      const res = await axiosInstance.get(GetCardPrintingMembers)
      setMembers(res.data || [])
    } catch {
      toast.error('Failed to load members')
    }
  }

  useEffect(() => {
    getMembers()
  }, [])

  const handleMemberChange = async (memberId) => {
    if (!memberId) {
      setCardData(null)
      return
    }

    setLoading(true)
    try {
      // ── Replace this block with your real API call when ready ──
      // const res = await axiosInstance.get(`${GetCardPrintingData}?memberId=${memberId}`)
      // const data = res.data

      await new Promise((r) => setTimeout(r, 400))
      const data = { ...STATIC_CARD, id: memberId }
      setCardData(data)
    } catch {
      toast.error('Failed to fetch card data')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    setCardData(null)
  }

  const PhotoPlaceholder = () => (
    <div
      style={{
        width: 72,
        height: 90,
        borderRadius: 6,
        flexShrink: 0,
        background: '#dde3ea',
        border: '1px solid #c8d8e8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 28,
        color: '#999',
      }}
    >
      👤
    </div>
  )

  const handlePrintCard = async (userId) => {
    try {
      const res = await axiosInstance.get(
        `${GetCardPrintingData}?userId=${userId}`,
      )

      const pdfFileName = res.data

      // Check if response is NOTFOUND
      if (pdfFileName === 'NOTFOUND') {
        toast.error('PDF file not found')
        return
      }

      if (pdfFileName) {
        window.open(`${PdfPath}${pdfFileName}`, '_blank')
      } else {
        toast.error('PDF file not found')
      }
    } catch (error) {
      toast.error('Failed to print card')
    }
  }

  return (
    <div className="row p-0 m-0">
      <div className="col-12 col-md-1 col-lg-2" />
      <div className="col-12 col-md-10 col-lg-8 page-background1 p-2 p-md-4">
        <div className="page-header">
          <h2>
            <CameraOutlined style={{ marginRight: 8 }} />
            Card Printing
          </h2>
        </div>

        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Member"
                name="member"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Select Member"
                  loading={loading}
                  onChange={handleMemberChange}
                  allowClear
                  onClear={handleCancel}
                >
                  {members.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} className="mb-3">
              {' '}
              <span style={{ color: 'red' }}>
                (This feature is available only for Monthly and Yearly
                Memberships.)
              </span>{' '}
            </Col>
          </Row>

          {cardData && (
            <Form.Item>
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={() => handlePrintCard(cardData.id)}
              >
                Print Card
              </Button>
              <Button style={{ marginLeft: 10 }} onClick={handleCancel}>
                Cancel
              </Button>
            </Form.Item>
          )}
        </Form>
      </div>
      <div className="col-12 col-md-1 col-lg-2" />
    </div>
  )
}
